var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.51309C0 1.12515 1.05345 0 2.35294 0H17.6471C18.9466 0 20 1.12515 20 2.51309V13.4869C20 14.8749 18.9466 16 17.6471 16H2.35294C1.05345 16 0 14.8749 0 13.4869V2.51309ZM2.35294 1.25654C1.70319 1.25654 1.17647 1.81912 1.17647 2.51309V13.4869C1.17647 14.1809 1.70319 14.7435 2.35294 14.7435H17.6471C18.2968 14.7435 18.8235 14.1809 18.8235 13.4869V2.51309C18.8235 1.81912 18.2968 1.25654 17.6471 1.25654H2.35294Z",
    fill: "#3E4E5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.6478C0 4.30082 0.263362 4.01953 0.588235 4.01953H19.4118C19.7366 4.01953 20 4.30082 20 4.6478C20 4.99479 19.7366 5.27608 19.4118 5.27608H0.588235C0.263362 5.27608 0 4.99479 0 4.6478Z",
    fill: "#3E4E5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.76562 8.67124C3.76562 8.32426 4.02899 8.04297 4.35386 8.04297H11.2558C11.5807 8.04297 11.8441 8.32426 11.8441 8.67124C11.8441 9.01823 11.5807 9.29951 11.2558 9.29951H4.35386C4.02899 9.29951 3.76562 9.01823 3.76562 8.67124Z",
    fill: "#3E4E5D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.76562 11.3509C3.76562 11.0039 4.02899 10.7227 4.35386 10.7227H8.74602C9.07089 10.7227 9.33425 11.0039 9.33425 11.3509C9.33425 11.6979 9.07089 11.9792 8.74602 11.9792H4.35386C4.02899 11.9792 3.76562 11.6979 3.76562 11.3509Z",
    fill: "#3E4E5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/creditCard.8936f1bd.svg";
export { ForwardRef as ReactComponent };